const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:5000/api";

const getHeaders = (token) => {
  const headers = {
    "Content-Type": "application/json",
  };

  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  return headers;
};

export { API_BASE_URL, getHeaders };
